export const SET_POPUP_STATS = 'SET_POPUP_STATS';

export const setPopupStats = (stats) => {
  return {
    type: SET_POPUP_STATS,
    payload: stats
  }
}
